//@ts-nocheck
import axiosInstance from './axiosSetup';
import { UserDataType } from '../types/commonTypes';
import { API_URL } from './apiMapper';
import axios from 'axios';
import { isWeb, getChannelId } from '../storage';
import { environment } from '../environments';
import { store } from '../store';
import { logout } from '../reducer/authSlice';
import { userLogout } from '../reducer/userSlice';
import CryptoJS from 'crypto-js';
import { delay } from 'redux-saga/effects';

export const fetchCounter = async (): Promise<number> => {
  const response = await axiosInstance.get('/counter');
  return response.data;
};

export const fetchUserData = async (): Promise<UserDataType> => {
  const response = await axiosInstance.get('/user/data');
  return response.data;
};

export const fetchContentFullDashboardData = async (
  language: string
): Promise<any> => {
  let lang = 'en-US';
  if (isWeb) {
    let storedLang = '';
    if (language) {
      storedLang = language;
    } else {
      storedLang = localStorage.getItem('language');
    }
    if (['en-US', 'fr'].includes(storedLang)) {
      lang = storedLang;
    }
  }
  try {
    const url = `https://${environment.contentful.host}/spaces/${environment.contentful.space}/environments/${environment.contentful.environment}/entries`;
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${environment.contentful.cdk}`,
      },
      params: {
        'sys.id[in]': environment.contentful['sys.id'],
        locale: isWeb ? lang : language === 'fr' ? language : lang,
        'metadata.tags.sys.id[in]':
          environment.contentful['metadata.tags.sys.id[in]'],
        include: environment.contentful.include,
      },
    });
    return response.data;
  } catch (error) {
    console.log('An Error ---->', error);
  }
};

export const signIn = async (apiName: string, data) => {
  let response;
  try {
    response = await axiosInstance.post(API_URL[apiName], data);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const passkeySignIn = async (
  apiName: string,
  data: {
    webauthn_encoded_result: string;
    flow: string;
    deviceId?: string;
    channel?: string;
    username: string;
  }
) => {
  let response;
  try {
    response = await axiosInstance.post(API_URL[apiName], data);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const passkeyRegister = async (
  apiName: string,
  data: {
    webauthn_encoded_result: string;
    accountId: string;
    customerId: string;
    username: string;
    flow: string;
  }
) => {
  let response;
  try {
    response = await axiosInstance.post(API_URL[apiName], data);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const passkeyDeregister = async (
  apiName: string,
  data: {
    userId: string;
    passkeyId: string;
    flow: string;
  }
) => {
  let response;
  try {
    response = await axiosInstance.post(API_URL[apiName], data);
    return {
      status: response.status,
      data: response.data,
      headers: response.headers,
    };
  } catch (error) {
    return error;
  }
};

export const passkeyList = async (
  apiName: string,
  data: {
    accountId: string;
    customerId: string;
    flow: string;
  }
) => {
  try {
    const response = await axiosInstance.post(API_URL[apiName], data);
    return { status: response.status, data: response.data };
  } catch (error) {
    return error;
  }
};

export const fetchHasPasskeyRegistered = async (
  accountId: string,
  customerId: string
) => {
  try {
    const response = await axiosInstance.get(
      API_URL.has_passkey_registered(accountId, customerId)
    );
    return { status: response.status, data: response.data };
  } catch (error) {
    return error;
  }
};

export const signOut = async (
  apiName: string,
  data: any,
  accountId: string
) => {
  let response;
  try {
    response = await axiosInstance.post(API_URL[apiName](accountId), data);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const fetchAccountDetails = async (
  apiName: string,
  accId: string,
  customerId: string
) => {
  try {
    const response = await axiosInstance.get(
      API_URL[apiName](accId, customerId)
    );
    return response.data;
  } catch (e) {
    return e;
  }
};

export const getAccountDetails = async (
  apiName: string,
  accId: string,
  isRefresh?: boolean
) => {
  const headers = isRefresh ? { isRefresh: 'true' } : {};
  try {
    const response = await axiosInstance.get(
      API_URL[apiName](accId),
      { headers } // Add the headers object here
    );
    return response.data;
  } catch (error) {
    handleLogout();
    throw error;
  }
};

export const fetchAddressDetails = async (
  apiName: string,
  accId: string,
  customerId: string
) => {
  try {
    const response = await axiosInstance.get(
      API_URL[apiName](accId, customerId)
    );
    return response.data;
  } catch (e) {
    return e;
  }
};

export const updateAddressDetails = async (
  apiName: string,
  accId: string,
  customerId: string,
  requestBody: any
) => {
  try {
    const response = await axiosInstance.put(
      API_URL[apiName](accId, customerId),
      requestBody
    );
    return response.data;
  } catch (e) {
    return e;
  }
};

export const fetchEmailDetails = async (
  apiName: string,
  accId: string,
  customerId: string
) => {
  try {
    const response = await axiosInstance.get(
      API_URL[apiName](accId, customerId)
    );
    return response.data;
  } catch (e) {
    return e;
  }
};

export const updateEmailDetails = async (
  apiName: string,
  accId: string,
  customerId: string,
  requestBody: any
) => {
  try {
    const response = await axiosInstance.put(
      API_URL[apiName](accId, customerId),
      requestBody
    );
    return response.data;
  } catch (e) {
    return e;
  }
};

export const updatePreferredLangDetails = async (
  apiName: string,
  accId: string,
  customerId: string,
  requestBody: any
) => {
  try {
    const response = await axiosInstance.put(
      API_URL[apiName](accId, customerId),
      requestBody
    );
    return response.data;
  } catch (e) {
    return e;
  }
};

export const fetchStatementPrefDetails = async (
  apiName: string,
  accId: string,
  customerId: string
) => {
  try {
    const response = await axiosInstance.get(
      API_URL[apiName](accId, customerId)
    );
    return response.data;
  } catch (e) {
    return e;
  }
};

export const updateStatementPrefDetails = async (
  apiName: string,
  accId: string,
  customerId: string,
  requestBody: any
) => {
  try {
    const response = await axiosInstance.put(
      API_URL[apiName](accId, customerId),
      requestBody
    );
    return response.data;
  } catch (e) {
    return e;
  }
};

export const fetchSecureMessage = async (
  apiName: string,
  accId: string,
  customerId: string
) => {
  try {
    const response = await axiosInstance.get(
      API_URL[apiName](accId, customerId)
    );
    return response.data;
  } catch (e) {
    return e;
  }
};

export const fetchSecureMessageDetails = async (
  apiName: string,
  accId: string,
  customerId: string,
  detailId: string
) => {
  try {
    const response = await axiosInstance.get(
      API_URL[apiName](accId, customerId, detailId)
    );
    return response.data;
  } catch (e) {
    return e;
  }
};

export const fetchSecureMessageOptions = async (
  apiName: string,
  accId: string,
  customerId: string
) => {
  try {
    const response = await axiosInstance.get(
      API_URL[apiName](accId, customerId)
    );
    console.log('response_options', response?.data);
    return response.data;
  } catch (e) {
    return e;
  }
};

export const updateSecureMessage = async (
  apiName: string,
  accId: string,
  customerId: string,
  requestBody: any
) => {
  try {
    const response = await axiosInstance.post(
      API_URL[apiName](accId, customerId),
      requestBody
    );
    console.log('updateSecureMessage_created', response?.data);
    return response.data;
  } catch (e) {
    return e;
  }
};

export const fetchPhoneDetails = async (
  apiName: string,
  accId: string,
  customerId: string
) => {
  try {
    const response = await axiosInstance.get(
      API_URL[apiName](accId, customerId)
    );
    return response.data;
  } catch (e) {
    return e;
  }
};

export const updatePhoneDetails = async (
  apiName: string,
  accId: string,
  customerId: string,
  requestBody: any
) => {
  try {
    const response = await axiosInstance.put(
      API_URL[apiName](accId, customerId),
      requestBody
    );
    return response.data;
  } catch (e) {
    return e;
  }
};

const handleLogout = () => {
  if (isWeb) {
    store.dispatch(userLogout());
  } else {
    store.dispatch(logout());
  }
};

export const getEPPDetails = async (
  apiName: string,
  accountId: string,
  customerId: string,
  isRefresh?: boolean
) => {
  const headers = isRefresh ? { isRefresh: 'true' } : {};
  try {
    const response = await axiosInstance.get(
      API_URL[apiName](accountId, customerId),
      { headers }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Fetch request card status
export const getRequestCard = async (
  apiName: string,
  accountId: string,
  customerId: string
) => {
  try {
    const response = await axiosInstance.get(
      API_URL[apiName](accountId, customerId)
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update request card status
export const updateRequestCard = async (
  apiName: string,
  accountId: string,
  customerId: string,
  requestBody: any
) => {
  try {
    const response = await axiosInstance.put(
      API_URL[apiName](accountId, customerId),
      requestBody
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Fetch card lock status
export const getCardLockStatus = async (
  apiName: string,
  accountId: string,
  customerId: string
) => {
  try {
    const response = await axiosInstance.get(
      API_URL[apiName](accountId, customerId)
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching card lock status: ${error}`);
    throw new Error('Failed to fetch card lock status');
  }
};

// Update card lock status
export const updateCardLockStatus = async (
  apiName: string,
  accountId: string,
  customerId: string,
  status: boolean
) => {
  try {
    const response = await axiosInstance.post(
      API_URL[apiName](accountId, customerId),
      {
        lockCard: status,
      }
    );
    return response.data;
  } catch (error) {
    console.error(`Error updating card lock status: ${error}`);
    throw new Error('Failed to update card lock status');
  }
};

// Fetch Popup status
export const getPopupStatus = async (
  apiName: string,
  accountId: string,
  customerId: string
) => {
  try {
    const response = await axiosInstance.get(
      API_URL[apiName](accountId, customerId)
    );
    ('response getPopupStatus', response.data);
    return response.data;
  } catch (error) {
    console.error(`Error fetching card lock status: ${error}`);
    throw new Error('Failed to fetch card lock status');
  }
};

// Update popup status
export const updatePopupStatus = async (
  apiName: string,
  accountId: string,
  customerId: string,
  status: boolean
) => {
  try {
    const response = await axiosInstance.put(
      API_URL[apiName](accountId, customerId),
      {}, // empty object for request body since we're using query parameters
      {
        params: {
          PopupToUpdate: status,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(`Error updating Popup status: ${error}`);
    throw new Error('Failed to update Popup status');
  }
};

// Fetch Popup status
export const getAccountStatus = async (
  apiName: string,
  accountId: string,
  customerId: string,
  isRefresh?: boolean
) => {
  const headers = isRefresh ? { isRefresh: 'true' } : {};
  try {
    const response = await axiosInstance.get(
      API_URL[apiName](accountId, customerId),
      { headers }
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching card lock status: ${error}`);
    throw new Error('Failed to fetch card lock status');
  }
};

export const fetchRewards = async (
  apiName: string,
  accountId: string,
  cardLastFourDigits: string
) => {
  try {
    // Making the API call using the dynamic apiName and accountId
    const response = await axiosInstance.get(
      API_URL[apiName](accountId, cardLastFourDigits)
    );
    return response.data; // Returning only the data from the response
  } catch (error) {
    console.error('Error fetching rewards:', error);
    throw new Error(error.response?.data?.message || 'Failed to fetch rewards');
  }
};

export const fetchTransactions = async (
  apiName: string,
  accId: string,
  customerId: string,
  limit?: number,
  cycleStartDate?: string,
  customerTypeId?: string,
  fromDate?: string,
  toDate?: string,
  merchantCategory?: string,
  allTransactions?: boolean,
  offset?: number,
  isRefresh?: boolean
) => {
  const headers = isRefresh ? { isRefresh: 'true' } : {};
  try {
    const config = { headers: headers };
    const response = await axiosInstance.get(
      API_URL[apiName](
        accId,
        customerId,
        limit,
        cycleStartDate,
        customerTypeId,
        fromDate,
        toDate,
        merchantCategory,
        offset,
        allTransactions,
        isRefresh
      ),
      {
        isTransactionRefresh: isRefresh,
      }
    );
    return response.data;
  } catch (e) {
    return e;
  }
};

export const fetchContactPreferences = async (
  apiName: string,
  accId: string,
  primaryCustomerId: string,
  customerId: string
) => {
  try {
    const response = await axiosInstance.get(
      API_URL[apiName](accId, primaryCustomerId, customerId)
    );
    return response.data;
  } catch (e) {
    return e;
  }
};

export const fetchDisplayBusinessName = async (
  apiName: string,
  accId: string
) => {
  try {
    const response = await axiosInstance.get(API_URL[apiName](accId));
    return response.data;
  } catch (e) {
    return e;
  }
};

export const fetchStatements = async (
  apiName: string,
  accId: string,
  customerId: string,
  nextEndDate: string,
  isRefresh?: boolean
) => {
  const headers = isRefresh ? { isRefresh: 'true' } : {};
  try {
    const response = await axiosInstance.get(
      API_URL[apiName](accId, customerId, nextEndDate),
      { headers }
    );
    return response.data;
  } catch (e) {
    return e;
  }
};

export const fetchInitiateStatement = async (
  apiName: string,
  accId: string,
  customerId: string,
  statementId: string,
  statementDate: string,
  cycleDate: string,
  isRefresh?: boolean
) => {
  const headers = isRefresh ? { isRefresh: 'true' } : {};

  try {
    const response = await axiosInstance.get(
      API_URL[apiName](accId, customerId, statementId),
      { headers:{
          ...headers,
          statementDate: statementDate,
          cycleDate: cycleDate,
      } }
    );
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const fetchJobStatusStatement = async (
  apiName: string,
  accId: string,
  customerId: string,
  jobId: string,
  statementId: string,
  statementDate: string,
  cycleDate: string,
  isRefresh?: boolean
) => {
  const headers = isRefresh ? { isRefresh: 'true' } : {};
  try {
    const response = await axiosInstance.get(
      API_URL[apiName](accId, customerId, jobId),
     { headers:{
          ...headers,
          statementDate: statementDate,
          cycleDate: cycleDate,
          statementId:statementId
      } }
    );
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const fetchStatementsPDF = async (
  apiName: string,
  accId: string,
  customerId: string,
  isRefresh?: boolean
) => {
  const headers = isRefresh ? { isRefresh: 'true' } : {};
  try {
    const response = await axiosInstance.get(
      API_URL[apiName](accId, customerId),
      { headers }
    );
    return response.data;
  } catch (e) {
    return e;
  }
};

//  status validate passcode
export const fetchValidatePasscode = async (apiName: string, payload: any) => {
  try {
    const response = await axiosInstance.post(API_URL[apiName], payload);
    return response.data;
  } catch (error) {
    return error;
  }
};

// //  status generate code for device
export const fetchGeneratecodefordevice = async (
  apiName: string,
  payload: any
) => {
  try {
    const response = await axiosInstance.post(API_URL[apiName], payload);
    return response;
  } catch (error) {
    return error;
  }
};

//  status preferences User
export const preferencesUserStatus = async (apiName: string, payload: any) => {
  try {
    const response = await axiosInstance.post(API_URL[apiName], payload);
    return response.data;
  } catch (error) {
    return error;
  }
};

const getPasskeyOtpHeaders = (passkeyToken?: string) =>
  passkeyToken ? { 'X-Passkey-Token': passkeyToken } : {};

// Passkey OTP — isolated from sign-in two-factor flow
export const fetchPasskeyPreferencesUser = async (payload: {
  username: string;
  passkeyToken: string;
}) => {
  try {
    const response = await axiosInstance.post(
      API_URL.passkey_preferences_user,
      {
        username: payload?.username,
        flow: 'PATH_PREF_API',
      },
      { headers: getPasskeyOtpHeaders(payload?.passkeyToken) }
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

export const fetchPasskeyGenerateCode = async (payload: {
  preferenceType: string;
  username: string;
  passkeyToken: string;
  recaptchaToken?: string | null;
}) => {
  try {
    const { preferenceType, username, passkeyToken, recaptchaToken } = payload;
    const response = await axiosInstance.post(
      API_URL.passkey_generate_code,
      {
        preferenceType,
        username,
        flow: 'PATH_GEN_CODE_API',
        ...(typeof recaptchaToken === 'string' && recaptchaToken.length > 0
          ? { recaptchaToken }
          : {}),
      },
      { headers: getPasskeyOtpHeaders(passkeyToken) }
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

export const fetchPasskeyValidatePasscode = async (payload: {
  oneTimePassCode: string;
  username: string;
  passkeyToken: string;
  recaptchaToken?: string | null;
}) => {
  try {
    const { oneTimePassCode, username, passkeyToken, recaptchaToken } =
      payload;
    const response = await axiosInstance.post(
      API_URL.passkey_validate_passcode,
      {
        username,
        oneTimePassCode,
        flow: 'PATH_VALID_CODE_API',
        ...(typeof recaptchaToken === 'string' && recaptchaToken.length > 0
          ? { recaptchaToken }
          : {}),
      },
      { headers: getPasskeyOtpHeaders(passkeyToken) }
    );
    // Deletion OTP can return a plain success string (no statusCode in the body).
    return {
      status: response.status,
      statusCode: response.status,
      data: response.data,
    };
  } catch (error) {
    return error;
  }
};

export const fetchViewStatement = async (
  apiName: string,
  accId: string,
  customerId: string,
  statementId: string,
  statementDate: string,
  cycleDate: string,
  recaptchaToken?: any,
  loaderFunction: any
): Promise<ArrayBuffer> => {
  try {
    const url = API_URL[apiName](accId, customerId, statementId);

    /* ---------------- Helpers ---------------- */
    const delayWithLogs = async (ms = 5000) => {
      const seconds = ms / 1000;
      for (let i = 1; i <= seconds; i++) {
        console.log(`Waiting... ${i}s`);
        await new Promise((res) => setTimeout(res, 1000));
      }
    };

    const getHeader = (h: any, name: string) => {
      if (!h) return undefined;
      const key = Object.keys(h).find(
        (k) => k.toLowerCase() === name.toLowerCase()
      );
      return key ? h[key] : undefined;
    };

    const concatBuffers = (arr: ArrayBuffer[]) => {
      const total = arr.reduce((sum, b) => sum + b.byteLength, 0);
      const u8 = new Uint8Array(total);
      let offset = 0;

      for (const b of arr) {
        u8.set(new Uint8Array(b), offset);
        offset += b.byteLength;
      }
      return u8.buffer;
    };

    const arrayBufferToString = (ab: ArrayBuffer) =>
      new TextDecoder('utf-8').decode(new Uint8Array(ab));

    const throwIfJsonError = (data: ArrayBuffer, headers: any, label = '') => {
      const ct = String(getHeader(headers, 'content-type') || '').toLowerCase();

      if (ct.includes('json') || ct.includes('text')) {
        const text = arrayBufferToString(data);
        let msg = text;
        try {
          const j = JSON.parse(text);
          msg = j?.message || j?.error || text;
        } catch {}
        throw new Error(`${label}${msg}`);
      }
    };

    // RN-safe ArrayBuffer → WordArray
    const arrayBufferToWordArray = (buffer: ArrayBuffer) => {
      const u8 = new Uint8Array(buffer);
      const words = [];
      for (let i = 0; i < u8.length; i += 4) {
        words.push(
          ((u8[i] || 0) << 24) |
            ((u8[i + 1] || 0) << 16) |
            ((u8[i + 2] || 0) << 8) |
            (u8[i + 3] || 0)
        );
      }
      return CryptoJS.lib.WordArray.create(words, u8.length);
    };

    let completed = 0;
    const statementToken = isWeb ? await recaptchaToken('statement_download') : null
    /* ---------------- Segment 0 ---------------- */
    const first = await axiosInstance
      .get(url, {
        params: statementToken
          ? { recaptchaToken: statementToken }
          : {},
        headers: {
          accept: '*/*',
          channel: getChannelId,
          segment: 0,
          'Cache-Control': 'no-cache',
          'Accept-Encoding': 'identity',
          statementDate: statementDate,
          cycleDate: cycleDate,
        },
        responseType: 'arraybuffer',
      })
      .then((resp) => {
        const percentage = 10;
        console.log('loaderPerc', percentage);
        loaderFunction(percentage);

        return {
          seg: 0,
          data: resp.data,
          headers: resp.headers,
        };
      });

    throwIfJsonError(first.data, first.headers, 'Segment 0 error: ');

    const segmentCount =
      Number(
        getHeader(first.headers, 'x-segment-count') ||
          getHeader(first.headers, 'X-Segment-Count')
      ) || 0;

    const buffers: ArrayBuffer[] = segmentCount === 0 ? [first.data] : [];

    /* ---------------- Remaining Segments ---------------- */
    if (segmentCount > 1) {
      const segmentStatus = String(
        getHeader(first.headers, 'x-segment-status') ||
          getHeader(first.headers, 'X-Segment-Status') ||
          'false'
      ).toLowerCase();
      const waitTime = Number(
        getHeader(first.headers, 'x-segment-waittime') ||
          getHeader(first.headers, 'X-Segment-WaitTime') ||
          '3'
      );
      if (segmentStatus !== 'false') {
        await delayWithLogs(waitTime * 1000);
      }
      const requests = [];
      for (let seg = 0; seg < segmentCount; seg++) {
        const segmentToken = isWeb ? await recaptchaToken('segment_download') : null
        requests.push(
          axiosInstance
            .get(url, {
              params: segmentToken
                ? { recaptchaToken: segmentToken }
                : {},
              headers: {
                accept: '*/*',
                channel: getChannelId,
                segment: seg,
                'Cache-Control': 'no-cache',
                'Accept-Encoding': 'identity',
                statementDate: statementDate,
                cycleDate: cycleDate,
              },
              responseType: 'arraybuffer',
            })
            .then((resp) => {
              completed += 1;

              const percentage = Math.round(
                (completed / segmentCount) * 100
              );
              console.log('loaderPerc', percentage);
              loaderFunction(percentage);

              return {
                seg,
                data: resp.data,
                headers: resp.headers,
              };
            })
        );
      }
      const results = await Promise.all(requests);

      results
        .sort((a, b) => {
          const aIdx = Number(getHeader(a.headers, 'x-segment-index')) ?? a.seg;
          const bIdx = Number(getHeader(b.headers, 'x-segment-index')) ?? b.seg;
          return aIdx - bIdx;
        })
        .forEach((r) => {
          throwIfJsonError(r.data, r.headers, `Segment ${r.seg} error: `);
          buffers.push(r.data);
        });
    }

    /* ---------------- Combine Buffers ---------------- */
    const combined = concatBuffers(buffers);
    await new Promise((res) => setTimeout(res, 200));

    /* ---------------- Checksum ---------------- */
    const checksum = getHeader(first.headers, 'x-checksum');
    if (checksum) {
      const expected = checksum.trim().toLowerCase();
      const computeHash = () => {
        const wa = arrayBufferToWordArray(combined);
        return CryptoJS.SHA256(wa).toString(CryptoJS.enc.Hex).toLowerCase();
      };

      let hash = computeHash();
      if (hash !== expected) {
        throw new Error(
          `Checksum mismatch after retry: expected ${expected}, got ${hash}`
        );
      }
    }

    return combined;
  } catch (e: any) {
    throw new Error(e?.message || 'Failed to download statement');
  }
};

export const downloadTransactions = async (
  apiName: string,
  accId: string,
  customerId: string,
  cycleDate: string,
  selectedFileType = '',
  recaptchaToken?: string | null | undefined
) => {
  try {
    console.log('recaptchaTokenTest', recaptchaToken);
    const response = await axiosInstance.get(
      API_URL[apiName](accId, customerId, cycleDate),
      {
        params: {
          format: selectedFileType === 'OFX' ? 'OFX' : 'CSV',
          recaptchaToken: recaptchaToken,
        },
      }
    );

    return response.data;
  } catch (e) {
    return e;
  }
};

export const fetchContactDetails = async (
  apiName: string,
  accId: string,
  customerId: string,
  isRefresh?: boolean
) => {
  const headers = isRefresh ? { isRefresh: 'true' } : {};
  try {
    const response = await axiosInstance.get(
      API_URL[apiName](accId, customerId),
      { headers }
    );
    return response.data;
  } catch (e) {
    return e;
  }
};

export const fetchCardDetailsType = async (
  apiName: string,
  accId: string,
  customerId: string
) => {
  try {
    const response = await axiosInstance.get(
      API_URL[apiName](accId, customerId)
    );
    return response.data;
  } catch (e) {
    return e;
  }
};
// name change
export async function fetchChangePassword(
  apiName: string,
  accId: string,
  customerId: string,
  username: string,
  oldPassword: string,
  newPassword: string,
  verifyPassword: string,
  recaptchaToken?: string
): Promise<any> {
  try {
    const response = await axiosInstance.put(
      API_URL[apiName](accId, customerId),
      {
        username: username,
        oldPassword: oldPassword,
        newPassword: newPassword,
        verifyPassword: verifyPassword,
        recaptchaToken: recaptchaToken,
      }
    );
    return response.data;
  } catch (error) {
    return error;
  }
}

export const updateActivateCard = async (
  apiName: string,
  accId: string,
  customerId: string,
  requestBody: any
) => {
  try {
    const response = await axiosInstance.put(
      API_URL[apiName](accId, customerId),
      requestBody
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

export const updateChangePin = async (
  apiName: string,
  accId: string,
  customerId: string,
  requestBody: any
) => {
  try {
    const response = await axiosInstance.put(
      API_URL[apiName](accId, customerId),
      requestBody
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

export const fetchRedeemRewards = async (
  apiName: string,
  accId: string,
  cardLastFourDigits: string,
  redemptionType: string
) => {
  try {
    const response = await axiosInstance.get(
      API_URL[apiName](accId, cardLastFourDigits, redemptionType)
    );
    return response.data;
  } catch (e) {
    return e;
  }
};

export const fetchRedeemRewardsPreferences = async (
  apiName: string,
  accId: string,
  cardLastFourDigits: string,
  redemptionType: string
) => {
  try {
    const response = await axiosInstance.get(
      API_URL[apiName](accId, cardLastFourDigits, redemptionType)
    );
    return response.data;
  } catch (e) {
    return e;
  }
};

export const updateRedeemRewardsPreferences = async (
  apiName: string,
  accountId: string,
  cardLastFourDigits: string,
  redemptionType: string,
  userIdType: string,
  emailAddress: string,
  fixedAccountRedemptionAmount: number,
  minAccountPurchaseThreshold: number,
  receiveEmailSw: boolean,
  receiveSMSSw: boolean,
  redemptionFrequency: string,
  smsNumber: string,
  recaptchaToken?: string
) => {
  try {
    const response = await axiosInstance.put(
      API_URL[apiName](accountId, cardLastFourDigits, redemptionType),
      {
        userIdType: userIdType,
        recaptchaToken: recaptchaToken,
        preferences: {
          emailAddress: emailAddress,
          fixedAccountRedemptionAmount: fixedAccountRedemptionAmount,
          minAccountPurchaseThreshold: minAccountPurchaseThreshold,
          receiveEmailSw: receiveEmailSw,
          receiveSMSSw: receiveSMSSw,
          redemptionFrequency: redemptionFrequency,
          smsNumber: smsNumber,
        },
      }
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

export const redeemRewardSearch = async (
  apiName: string,
  userId: string,
  redemptionType: string,
  userIdType: string,
  cardLastFourDigits: string
) => {
  try {
    const response = await axiosInstance.post(
      API_URL[apiName](cardLastFourDigits),
      {
        userIdType: userIdType,
        userId: userId,
        redemptionType: redemptionType,
      }
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

//  get rewards transaction data
export const fetchRewardsTransaction = async (
  apiName: string,
  cardLastFourDigits: string,
  offset: number,
  limit: number,
  userId: string,
  userIdType: string,
  fromDate: string,
  toDate: string,
  isYtd: boolean
) => {
  try {
    const response = await axiosInstance.post(
      API_URL[apiName](cardLastFourDigits, offset, limit, isYtd),
      {
        userId: userId,
        userIdType: userIdType,
        fromDate: fromDate,
        toDate: toDate,
      }
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

// get redeem rewards Authorization list
export const fetchRedeemRewardsAuthorization = async (
  apiName: string,
  accId: string,
  cardLastFourDigits: string,
  fromDate: string,
  toDate: string,
  includeResponse: boolean
) => {
  try {
    const response = await axiosInstance.get(
      API_URL[apiName](
        accId,
        cardLastFourDigits,
        fromDate,
        toDate,
        includeResponse
      )
    );
    return response.data;
  } catch (e) {
    return e;
  }
};

//  get rewards transaction data
export const updateRedeemRewardsAuthorization = async (
  apiName: string,
  accountId: string,
  accountIdType: string,
  processingCode: string,
  cardLastFourDigits: string,
  cardholderBillingAmount: string,
  transactionAmount: string,
  transactionDateAndTime: string,
  merchantCategoryCode: string,
  acquiringInstitutionIdCode: string,
  authorizationIdResponse: string,
  cardAcceptorIdCode: string,
  cardAcceptorNameAndLocation: string,
  cardholderBillingCurrencyCode: string,
  externalId: string,
  issuerCountryCode: string
) => {
  try {
    const response = await axiosInstance.post(API_URL[apiName], {
      accountId: accountId,
      accountIdType: accountIdType,
      processingCode: processingCode,
      cardLastFourDigits: cardLastFourDigits,
      cardholderBillingAmount: cardholderBillingAmount,
      transactionAmount: transactionAmount,
      transactionDateAndTime: transactionDateAndTime,
      merchantCategoryCode: merchantCategoryCode,
      acquiringInstitutionIdCode: acquiringInstitutionIdCode,
      authorizationIdResponse: authorizationIdResponse,
      cardAcceptorIdCode: cardAcceptorIdCode,
      cardAcceptorNameAndLocation: cardAcceptorNameAndLocation,
      cardholderBillingCurrencyCode: cardholderBillingCurrencyCode,
      externalId: externalId,
      issuerCountryCode: issuerCountryCode,
    });
    return response.data;
  } catch (error) {
    return error;
  }
};

//  update redeem rewards authorization reprocess data
export const updateRedeemRewardsAuthorizationReprocess = async (
  apiName: string,
  id: string,
  accountId: string,
  cardLastFourDigits: string,
  accountIdType: string,
  processedBy: string
) => {
  try {
    const response = await axiosInstance.post(
      API_URL[apiName](id, cardLastFourDigits),
      {
        accountId: accountId,
        accountIdType: accountIdType,
        processedBy: processedBy,
      }
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

// get redeem rewards Authorization list
export const fetchRedeemRewardsPoints = async (
  apiName: string,
  breakdownlevel: string,
  pointsRedeem: string,
  currentBalance: string,
  previousBalance: string,
  pointEarned: string,
  accountId: string,
  cardLastFourDigits: string,
  userIdType: string,
  fromDate: string,
  toDate: string
) => {
  try {
    const response = await axiosInstance.get(
      API_URL[apiName](
        breakdownlevel,
        pointsRedeem,
        currentBalance,
        previousBalance,
        pointEarned,
        accountId,
        cardLastFourDigits,
        userIdType,
        fromDate,
        toDate
      )
    );
    return response.data;
  } catch (e) {
    return e;
  }
};

export const fetchRedeemRewardsPointsAdjustmentsDetails = async (
  apiName: string,
  accountId: string,
  cardLastFourDigits: string,
  userIdType: string,
  fromDate: string,
  toDate: string,
  excludeOtherAccount: boolean,
  isYtd: boolean
) => {
  try {
    const response = await axiosInstance.get(
      API_URL[apiName](
        accountId,
        cardLastFourDigits,
        userIdType,
        fromDate,
        toDate,
        excludeOtherAccount,
        isYtd
      )
    );
    return response.data;
  } catch (e) {
    return e;
  }
};

//  update redeem rewards authorization reprocess data
export const RewardsUserPreference = async (
  apiName: string,
  userId: string,
  userIdType: string,
  includeSensitiveIdentifiers: boolean,
  programIdentifier: string,
  includeOnlyPrimary: boolean
) => {
  try {
    const response = await axiosInstance.post(API_URL[apiName], {
      userId: userId,
      userIdType: userIdType,
      includeSensitiveIdentifiers: includeSensitiveIdentifiers,
      programIdentifier: programIdentifier,
      includeOnlyPrimary: includeOnlyPrimary,
    });
    return response.data;
  } catch (error) {
    return error;
  }
};

// get employee profile
export const fetchemployeeProfile = async (
  apiName: string,
  accountId: string
) => {
  try {
    const response = await axiosInstance.get(API_URL[apiName](accountId));
    return response.data;
  } catch (e) {
    return e;
  }
};

export const fetchCaseHistory = async (
  apiName: string,
  accountId: string,
  customerId: string
) => {
  try {
    const response = await axiosInstance.get(
      API_URL[apiName](accountId, customerId)
    );
    return response.data;
  } catch (e) {
    return e;
  }
};

export const fetchAuthorizedUserOptions = async (
  apiName: string,
  accId: string,
  customerId: string
) => {
  try {
    const response = await axiosInstance.get(
      API_URL[apiName](accId, customerId)
    );
    return response.data;
  } catch (e) {
    return e;
  }
};

export const updateAuthorizedUser = async (
  apiName: string,
  accId: string,
  customerId: string,
  requestBody: any
) => {
  try {
    const response = await axiosInstance.post(
      API_URL[apiName](accId, customerId),
      requestBody
    );
    return response.data;
  } catch (e) {
    return e;
  }
};

export const fetchBankAccountDetail = async (
  apiName: string,
  accId: string
) => {
  try {
    const response = await axiosInstance.get(API_URL[apiName](accId));
    return response.data;
  } catch (e) {
    return e;
  }
};

export const getActiveAlerts = (
  endpoint: string,
  accountId: string,
  customerId: string
) => {
  try {
    const url = API_URL[endpoint](accountId, customerId);
    return axiosInstance
      .get(url)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.error('Error fetching active alerts:', error);
        throw error;
      });
  } catch (error) {
    console.error('Error in getActiveAlerts function:', error);
    throw error;
  }
};

export const getAlertContactPreferences = (
  endpoint: string,
  accountId: string,
  customerId: string
) => {
  try {
    const url = API_URL[endpoint];
    const requestBody = {
      customerIdentifiers: {
        accountId: accountId,
        enrolledCustomerId: '',
        unitName: '',
        enrolledUniqueId: '',
        customerId: customerId,
        cardNumber: '',
        contactMasterId: '',
        enrolledCardNumber: '',
        externalUserName: '',
        uniqueId: '',
      },
    };

    return axiosInstance
      .post(url, requestBody)
      .then((response) => {
        console.log('Alert contact preferences response:', response.data);
        return response.data;
      })
      .catch((error) => {
        console.error('Error fetching alert contact preferences:', error);
        throw error;
      });
  } catch (error) {
    console.error('Error in getAlertContactPreferences function:', error);
    throw error;
  }
};
//alert prefrence
export const updateAlertPreferences = (
  endpoint: string,
  accountId: string,
  customerId: string,
  userNotificationPreferences: any[],
  recaptchaToken?: string
) => {
  console.log('alert recaptchaToken', recaptchaToken);
  try {
    const url = API_URL[endpoint];

    if (!url) {
      console.error(`API endpoint '${endpoint}' not found in API_URL mapping`);
      throw new Error(`API endpoint '${endpoint}' not found`);
    }

    console.log(`Using API endpoint: ${url}`);

    // Format userNotificationPreferences to ensure alertDetails is properly structured
    const formattedPreferences = userNotificationPreferences.map((pref) => {
      return {
        alert: pref.alert,
        channels: {
          EMAIL: pref.channels.EMAIL,
          SMS: pref.channels.SMS,
        },
        alertDetails: pref.alertDetails,
        activeFlag: pref.activeFlag,
      };
    });

    const requestBody = {
      customerIdentifiers: {
        accountId: accountId,
        customerId: customerId,
      },
      userNotificationPreferences: formattedPreferences,
      ...(recaptchaToken && { recaptchaToken: recaptchaToken }),
    };

    console.log(
      'Update alert preferences request body:',
      JSON.stringify(requestBody)
    );

    return axiosInstance
      .put(url, requestBody)
      .then((response) => {
        console.log('Update alert preferences response:', response.data);
        return response.data;
      })
      .catch((error) => {
        console.error('Error updating alert preferences:', error);
        // Log more details about the error
        if (error.response) {
          console.error('Error response data:', error.response.data);
          console.error('Error response status:', error.response.status);
          console.error('Error response headers:', error.response.headers);
        } else if (error.request) {
          console.error('Error request:', error.request);
        }
        throw error;
      });
  } catch (error) {
    console.error('Error in updateAlertPreferences function:', error);
    throw error;
  }
};

export const fetchPhoneOptions = async (
  apiName: string,
  accountId: string,
  customerId: string
) => {
  try {
    const url = API_URL[apiName](accountId, customerId);
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching phone options:', error);
    throw error;
  }
};

export const updatePhoneForAlerts = async (
  apiName: string,
  accountId: string,
  customerId: string,
  requestBody: any
) => {
  try {
    const url = API_URL[apiName](accountId, customerId);
    const response = await axiosInstance.put(url, requestBody);
    return response.data;
  } catch (error) {
    console.error('Error updating phone for alerts:', error);
    throw error;
  }
};

export const fetchEmailOptions = async (
  apiName: string,
  accountId: string,
  customerId: string
) => {
  try {
    const url = API_URL[apiName](accountId, customerId);
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching email options:', error);
    throw error;
  }
};

export const updateEmailForAlerts = async (
  apiName: string,
  accountId: string,
  customerId: string,
  requestBody: any
) => {
  try {
    const url = API_URL[apiName](accountId, customerId);
    const response = await axiosInstance.put(url, requestBody);
    return response.data;
  } catch (error) {
    console.error('Error updating email for alerts:', error);
    throw error;
  }
};

export const updateAlertContactPreferences = async (feature, requestBody) => {
  try {
    console.log(
      `API call to ${feature} with request:`,
      JSON.stringify(requestBody, null, 2)
    );
    const response = await axiosInstance.put(
      API_URL.update_alert_contact_preferences,
      requestBody
    );
    console.log(
      `API response from ${feature}:`,
      JSON.stringify(response.data, null, 2)
    );
    return response.data;
  } catch (error) {
    console.error('Error updating alert contact preferences:', error);
    if (error.response) {
      console.error('Error response data:', error.response.data);
      console.error('Error response status:', error.response.status);
      console.error('Error response headers:', error.response.headers);
    } else if (error.request) {
      console.error('Error request (no response received):', error.request);
    } else {
      console.error('Error message:', error.message);
    }
    throw error;
  }
};

export const sendSmsVerification = async (requestBody) => {
  try {
    console.log(
      `API call to send SMS verification with request:`,
      JSON.stringify(requestBody, null, 2)
    );
    const response = await axiosInstance.put(
      API_URL.send_sms_verification,
      requestBody
    );
    console.log(
      `API response from send SMS verification:`,
      JSON.stringify(response.data, null, 2)
    );
    return response.data;
  } catch (error) {
    console.error('Error sending SMS verification:', error);
    if (error.response) {
      console.error('Error response data:', error.response.data);
      console.error('Error response status:', error.response.status);
      console.error('Error response headers:', error.response.headers);
    } else if (error.request) {
      console.error('Error request (no response received):', error.request);
    } else {
      console.error('Error message:', error.message);
    }
    throw error;
  }
};

export const fetchRewardsHistoryPercentageDetails = async (
  apiName: string,
  accId: string
) => {
  console.log('apiName, accId', apiName, accId);
  try {
    const response = await axiosInstance.get(API_URL[apiName](accId));
    return response.data;
  } catch (e) {
    return e;
  }
};

// Fetch EPP options for a transaction
export const fetchEppOptions = async (
  apiName: string,
  accountId: string,
  customerId: string,
  activityId: string
) => {
  try {
    const url = API_URL[apiName](accountId, customerId, activityId);
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching EPP options:', error);
    // Return an error object that includes a data property to prevent undefined.data errors
    return {
      error: true,
      data: {
        message: 'Failed to fetch EPP options',
        details: error?.message || 'Unknown error',
      },
    };
  }
};

// Create EPP plan
export const createEppPlan = async (
  apiName: string,
  accountId: string,
  customerId: string,
  requestBody: {
    activityId: string;
    optionCode: string;
    planName: string;
  }
) => {
  try {
    const url = API_URL[apiName](accountId, customerId);
    console.log('Creating EPP plan with URL:', url);
    console.log('Request Body:', JSON.stringify(requestBody));

    const response = await axiosInstance.post(url, requestBody);
    return response.data;
  } catch (error) {
    console.error('Error creating EPP plan:', error);
    throw error;
  }
};

// Create Zero Percent EPP plan
export const createZeroPercentEpp = async (
  apiName: string,
  requestBody: {
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
    account_id: string;
    customer_id: string;
    reference_number: string;
    last_four_cc: string;
    ban: string;
    purchase_date: string;
    purchase_amount: string;
    primary_cardholder: string;
    resident_of_quebec: string;
    province: string;
    type: string;
    offerTerm: string;
    imei: Array<{ imei_number: string }>;
    language: string;
    dealer_code: string;
    rep_email: string;
  }
) => {
  try {
    const url = API_URL[apiName];
    console.log('Creating Zero Percent EPP with URL:', url);
    console.log('Zero Percent EPP Request Body:', JSON.stringify(requestBody));

    // Explicitly set headers to ensure content type is application/json
    const response = await axiosInstance.post(url, requestBody, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  } catch (error) {
    console.error('Error creating Zero Percent EPP plan:', error);
    throw error;
  }
};

// BANK LINKAGE API CALLS
export const fetchBanDetailsAPI = async (
  apiName: string,
  ban: string,
  accountId: string,
  isRefresh?: boolean
) => {
  const headers = isRefresh ? { isRefresh: 'true' } : {};
  const response = await axiosInstance.get(API_URL[apiName](ban, accountId), {
    headers,
  });
  return response.data;
};

export const fetchRCIAccountStatus = async (
  apiName: string,
  accountId?: string
) => {
  try {
    const url = API_URL[apiName](accountId);
    const response = await axiosInstance.get(url, { accountId });
    return response.data;
  } catch (e) {
    console.log('error', e);
    return e;
  }
};

export const fetchRewarduser = async (apiName: string, user_id: string) => {
  try {
    const url = API_URL[apiName](user_id);
    const response = await axiosInstance.get(url, { user_id });
    return response.data;
  } catch (e) {
    console.log('error', e);
    return e;
  }
};

export const fetchRCIAccount = async (apiName: string, accountId?: string) => {
  try {
    const url = API_URL[apiName](accountId);
    const response = await axiosInstance.get(url, { accountId });
    console.log('response_fetchRCIAccount', response.data);
    return response.data;
  } catch (e) {
    console.log('error', e);
    return e;
  }
};

export const initiateLinkCardAPI = async (apiName: string, payload: any) => {
  const { accountId, customerId, appCode } = payload;
  const url = API_URL[apiName](accountId, customerId);

  console.log('apiName, accountId', apiName, payload);
  try {
    const response = await axiosInstance.post(url, { appCode });
    console.log('response', response);
    return response.data;
  } catch (e) {
    console.log('error', e);
    return e;
  }
};

export const validateSelectedAccountAPI = async (
  apiName: string,
  payload: any
) => {
  const { accountId, customerId, rciAccount } = payload;
  console.log('validateSelectedAccountAPI_payload', payload);
  const url = API_URL[apiName](accountId, customerId);
  try {
    const response = await axiosInstance.post(url, {
      rciAccount,
    });
    return response.data;
  } catch (e) {
    return e;
  }
};

export const linkSelectedAccountAPI = async (apiName: string, payload: any) => {
  const { accountId, customerId, ban } = payload;
  console.log('[linkSelectedAccountAPI] payload:', payload);
  const url = API_URL[apiName](accountId, customerId);
  try {
    const response = await axiosInstance.post(url, {
      ban,
    });
    console.log('[linkSelectedAccountAPI] Success response:', response.data);
    return response.data;
  } catch (e: any) {
    console.log('[linkSelectedAccountAPI] Error caught:', e);
    
    // The axios interceptor already processed the error
    // If it's a 409 wrapped in 500, it will be: { status: '409', detail: '...', title: '...' }
    // If it's a generic error, it will be: { statusCode: 500, error: {...} }
    
    console.log('[linkSelectedAccountAPI] Returning caught error:', e);
    return e;
  }
};

export const generateOtpAPI = async (apiName: string, payload: any) => {
  const { accountId, mobileNumber, language, recaptchaToken } = payload;
  console.log('payload', payload);
  const url = API_URL[apiName](accountId);
  try {
    const response = await axiosInstance.post(url, {
      mobileNumber,
      language,
      recaptchaToken,
    });
    return response.data;
  } catch (e) {
    return e;
  }
};

export const submitOtpAPI = async (apiName: string, payload: any) => {
  const { accountId, mobileNumber, otp, language, recaptchaToken } = payload;
  console.log('payload', payload);
  const url = API_URL[apiName](accountId);
  try {
    const response = await axiosInstance.post(url, {
      mobileNumber,
      otp,
      language,
      recaptchaToken,
    });
    return response.data;
  } catch (e) {
    return e;
  }
};

export const unlinkAccountAPI = async (apiName: string, payload: any) => {
  const { ban, accountId, customerId } = payload;
  const url = API_URL[apiName](accountId, customerId);
  try {
    const response = await axiosInstance.post(url, {
      ban,
    });
    return response.data;
  } catch (e) {
    return e;
  }
};

export const fetchViewRlhRewards = async (
  apiName: string,
  ban: string,
  accountId: string
) => {
  try {
    const url = API_URL[apiName](ban, accountId);
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching for ban:', error);
    throw error;
  }
};
export const getAppCodeApi = async (apiName: string, timestamp: string) => {
  try {
    const url = API_URL[apiName](timestamp);
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('App code API error:', error);
    throw error.response?.data || error;
  }
};

export const fetchTargetedOffer = async (
  apiName: string,
  accountId: string,
  customerId: string
) => {
  try {
    const response = await axiosInstance.get(
      API_URL[apiName](accountId, customerId),
      {
        headers: {
          includeAllOffers: 'false',
        },
      }
    );
    console.log('response.data', response);
    return response.data;
  } catch (e) {
    console.log('response.data', e);
    return e;
  }
};

export const fetchOfferPreferences = async (
  apiName: string,
  accountId: string,
  customerId: string,
  offerPreference: string,
  endDate: string
) => {
  try {
    const url = API_URL[apiName](
      accountId,
      customerId,
      offerPreference,
      endDate
    );
    console.log('Calling offer preference API:', {
      url,
      accountId,
      customerId,
      offerPreference,
    });
    const response = await axiosInstance.put(url);
    console.log('Offer preference API response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error calling offer preference API:', error);
    return error;
  }
};

export const fetchTargetOfferPrefSubmit = async (
  apiName: string,
  accountId: string,
  customerId: string,
  bankAccountId: string,
  offerStatus: string,
  offerKeyValue: string,
  expiryDate: string
) => {
  try {
    const response = await axiosInstance.put(
      API_URL[apiName](accountId, customerId),
      {
        bankAccountId: bankAccountId,
        offerStatus: offerStatus,
        offerKeyValue: offerKeyValue,
        expiryDate: expiryDate,
      }
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

// View Offers API
export const fetchViewOffers = async (
  apiName: string,
  accountId: string,
  customerId: string
) => {
  try {
    const response = await axiosInstance.get(
      API_URL[apiName](accountId, customerId),
      {
        headers: {
          includeAllOffers: 'true',
        },
      }
    );
    console.log('calling view offers api', response);
    return response.data;
  } catch (error) {
    console.log('error', error);
    return error;
  }
};

//LH apis
export const getRlhStatus = async (
  apiName: string,
  accountId: string,
  customerId: string
) => {
  console.log('calling lh');
  try {
    const response = await axiosInstance.get(
      API_URL[apiName](accountId, customerId)
    );
    console.log('response.data', response);
    return response.data;
  } catch (e) {
    console.log('response.data', e);
    return e;
  }
};

export const getRlhRewardStatus = async (
  apiName: string,
  accountId: string,
  customerId: string
) => {
  try {
    const response = await axiosInstance.get(
      API_URL[apiName](accountId, customerId)
    );
    console.log('response.data', response);
    return response.data;
  } catch (e) {
    console.log('response.data', e);
    return e;
  }
};

export const lhSsoLogin = async (
  apiName: string,
  accountId: string,
  customerId: string,
  productName: string,
  logouturl: string,
  firstName: string,
  lastName: string
) => {
  try {
    const response = await axiosInstance.post(
      API_URL[apiName](accountId, customerId),
      {},
      {
        headers: {
          productName: productName,
          logouturl: logouturl,
          firstName: firstName,
          lastName: lastName,
        },
      }
    );
    return response.data;
  } catch (error) {
    return error;
  }
};


export const submitEntertainmentCreditForm = async (apiName: string,accountId: string, data: any) => {
  console.log("apiname calling",apiName,data)
  let response;
  try {
    response = await axiosInstance.post(API_URL[apiName](accountId), {...data});
    console.log("response from server",response);
    return response.data;
  } catch (error) {
    console.log("error from server",error)
    return error;
  }
};
// Fetch Insurance Detail - Account Protection
export const fetchAccountProtectionInsuranceDetails = async (
  apiName: string,
  accountId: string,
  customerId: string,
) => {
  try {
    const url = API_URL[apiName](accountId, customerId);
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching account protection insurance details:', error);
    return error;
  }
};

//post Account Protection Service Already enrolled
export const SubmitEnrollAccountProtectionService = async (
  apiName: string,
  accountId: string,
  customerId: string,
  requestBody: any
) => {
  
  const payload = {
      sourceChannel: isWeb ? "101" : "201",
    ...requestBody
  }
  console.log("requestBody for form",payload)
   try {
    const response = await axiosInstance.post(
      API_URL[apiName](accountId, customerId),
      payload
    );
    return response;
  } catch (e) {
    return e;
  }
};